import { connect } from 'react-redux';
import React from 'react';
import { List as DictList, mapDispatchToProps } from '../List';
import { UrlWrappedLink, LinkLikeButton } from '../../../../util/util.jsx';
import RoleConfigFilter, { hasUserAnyRole } from '../../../auth/RoleConfigFilter.jsx';
import { Glyphicon } from 'react-bootstrap';
import { REF_NAME, REF_PATH, NAME } from './Const';
import { List as ImmutableList } from 'immutable';
import trash from '../../../../../style/trash.png';
import pencil from '../../../../../style/pencil.png';

class List extends DictList {
  constructor() {
    super();
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
    this.setName(NAME);
  }

  showAddButton() {
    return hasUserAnyRole(['ROLE_ADMIN',
      'ROLE_OPERATIONS', 'ROLE_OPERATIONS_HEAD']);
  }

  renderModificationButtons(id, ref) {
    return (
      <RoleConfigFilter
        roles={['ROLE_ADMIN',
          'ROLE_OPERATIONS', 'ROLE_OPERATIONS_HEAD']}
      >
        <div className={'reference-mod-column'}>
          {ref.hidden ?
            <LinkLikeButton onClick={() => this.restore(id)}>
              <Glyphicon
                title="Restore" id={`restore_${id}`} glyph="repeat"
              />
            </LinkLikeButton>
            :
            !ref.predefine &&
              <LinkLikeButton onClick={() => { this.openModal(id); }}>
                <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
              </LinkLikeButton>
          }
          <UrlWrappedLink url={`/references/${ref.refPath}/${id}`} id={`edit_${id}`}>
            <img
              src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
            />
          </UrlWrappedLink>
        </div>
      </RoleConfigFilter>);
  }
}

export default connect((state) =>
  ({ refs: state.getIn(['references', 'simple', REF_PATH], new ImmutableList()) }),
mapDispatchToProps(REF_NAME, REF_PATH))(List);
